<div class="notification-container">
  <app-sidenav-header [title]="title"></app-sidenav-header>
  <div class="flex flex-col justify-center items-center mt-50">
    <img src="../../../../assets/images/Group3912.svg">
    <div class="mat-body-1 mt-12 mb-4 fw-600">
      {{'NOTIFICATION.NO_NOTIFICATIONS' | transloco}}
    </div>
  </div>
</div>